"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.farm = void 0;

var _reducer = require("../../../client/lib/reducer");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.merge"));

var _lodash3 = _interopRequireDefault(require("lodash.assign"));

var _lodash4 = _interopRequireDefault(require("lodash.unionby"));

var Action = _interopRequireWildcard(require("./actions"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = [{
  key: 'canton',
  label: 'cantons',
  loadAction: Action.loadCantons,
  loadForeign: true
}, {
  key: 'brunchCantons',
  label: 'cantons',
  loadAction: Action.loadBrunchCantons
}, {
  key: 'project',
  label: 'projects',
  loadAction: Action.loadProjects,
  loadForeign: true
}, {
  // get all rubrics, initially used for product filter
  key: 'products',
  label: 'product',
  loadAction: Action.loadRubrics,
  loadForeign: true
}, {
  // get all products
  key: 'product',
  label: 'products',
  loadAction: Action.loadProduct,
  loadForeign: true
}, {
  key: 'vacation',
  label: 'Ferienangebote',
  loadAction: Action.loadVacation,
  loadForeign: true
}, {
  key: 'productionType',
  label: 'productionTypes',
  loadAction: Action.loadProductionType,
  loadForeign: true
}, {
  key: 'soldout',
  label: 'soldout',
  loadAction: Action.loadSoldout
}, {
  key: 'membership',
  label: 'Farm Memberships',
  loadAction: Action.loadMembership,
  loadForeign: true
}];
var initalPlaceSearch = {
  show: false,
  name: '',
  lat: '',
  lon: ''
};
var initialState = {
  loading: null,
  error: null,
  farms: null,
  farmsCache: {},
  totalFarms: 0,
  locations: [],
  allLocations: [],
  allOutletLocations: [],
  outletsAll: [],
  coordinates: null,
  activeFilter: {},
  search: '',
  suggestions: null,
  canton: null,
  brunchCantons: null,
  project: null,
  productionType: null,
  rubric: null,
  vacation: null,
  product: null,
  products: null,
  soldout: null,
  membership: [],
  productionLabels: [],
  getFilterConfig: function getFilterConfig() {
    return config;
  },
  placeSearch: initalPlaceSearch,
  detailViewPath: '',
  detailViewSearch: '',
  time: 0,
  offersAvailability: []
};

var rejectAction = function rejectAction(state, action) {
  var message = action.payload.message;
  return (0, _lodash2.default)({}, state, {
    loading: false,
    error: message
  });
};

var farm = (0, _reducer.createReducer)(initialState, {
  //Load project
  'search-farms_PENDING': function searchFarms_PENDING(state, action) {
    var newState = {
      loading: true,
      searchInProgress: true
    };

    if (!action.meta.loadMore) {
      newState.farms = [];
    }

    return (0, _lodash3.default)({}, state, newState);
  },
  'search-farms_FULFILLED': function searchFarms_FULFILLED(state, action) {
    var _action$payload = action.payload,
        body = _action$payload.body,
        headers = _action$payload.headers;
    var farms = (0, _lodash.default)(body, 'hits', []).map(function (farm) {
      return (0, _lodash.default)(farm, '_source', {});
    }); // prevent race condition. if the request is older than the state, do not update

    if (state.time > action.meta.time) {
      return state;
    }

    if (action.meta.loadMore) {
      farms = (0, _lodash4.default)(state.farms, farms, 'id');
    }

    var locations = (0, _lodash.default)(body, 'aggregations.mapLocations.buckets', []).map(function (location) {
      return location._source;
    });
    var allLocations = (0, _lodash.default)(body, 'aggregations.mapLocationsAll.buckets', []).map(function (location) {
      return location._source;
    });
    var offersAvailability = (0, _lodash.default)(body, 'aggregations.offers.buckets', []).map(function (offer) {
      return {
        name: offer.key,
        count: offer.doc_count
      };
    });
    var outletLocations = (0, _lodash.default)(body, 'aggregations.outletLocations.buckets', []).map(function (outlets) {
      return outlets;
    });
    var allOutletLocations = (0, _lodash.default)(body, 'aggregations.outletLocationsAll.buckets', []).map(function (location) {
      return location;
    });
    var outletsAll = (0, _lodash.default)(body, 'aggregations.outletsAll.buckets', []).map(function (outlets) {
      return outlets;
    }); // deal with placesearch

    var placeSearch = JSON.parse(JSON.stringify(initalPlaceSearch));
    var coordinatesHeader = headers.get('X-Elasticsearch-Coordinates');

    if (coordinatesHeader) {
      placeSearch.show = true;
      placeSearch.name = coordinatesHeader.split(',')[0];
      placeSearch.lon = coordinatesHeader.split(',')[1];
      placeSearch.lat = coordinatesHeader.split(',')[2];
    }

    return (0, _lodash3.default)({}, state, {
      farms: farms,
      searchInProgress: false,
      farmsCache: (0, _lodash2.default)({}, state.farmsCache, (0, _lodash.default)(action, 'payload.farms.hits.hits', []).map(function (farm) {
        return (0, _lodash.default)(farm, '_source', {});
      }).reduce(function (prev, cur) {
        var newFarmObj = {};
        newFarmObj[cur.id] = cur;
        return (0, _lodash2.default)({}, prev, newFarmObj);
      }, {})),
      loading: false,
      error: null,
      totalFarms: parseInt(headers.get('X-Elasticsearch-Total')) || 0,
      locations: locations,
      outletLocations: outletLocations,
      allOutletLocations: allOutletLocations,
      outletsAll: outletsAll,
      allLocations: allLocations,
      coordinates: action.meta.coordinates,
      search: action.meta.search,
      activeFilter: action.meta.activeFilter,
      placeSearch: placeSearch,
      detailViewPath: action.meta.detailViewPath,
      detailViewSearch: action.meta.detailViewSearch,
      time: action.meta.time,
      offersAvailability: offersAvailability
    });
  },
  'search-farms_REJECTED': function searchFarms_REJECTED(state, action) {
    var message = action.payload.message;
    return (0, _lodash3.default)({}, state, {
      loading: false,
      searchInProgress: false,
      error: message,
      totalFarms: 0,
      placeSearch: initalPlaceSearch
    });
  },
  'search-farms-start': function searchFarmsStart(state) {
    return (0, _lodash3.default)({}, state, {
      loading: true,
      farms: [],
      totalFarms: 0
    });
  },
  //Load suggestions
  'search-suggestions_PENDING': function searchSuggestions_PENDING(state) {
    return (0, _lodash3.default)({}, state);
  },
  'search-suggestions_FULFILLED': function searchSuggestions_FULFILLED(state, action) {
    var body = action.payload.body;
    var theme = action.meta.theme;
    var farms = (0, _lodash.default)(body, 'response.suggestions.options', []).map(function (farm) {
      return {
        farmname: (0, _lodash.default)(farm, '_source.farmname'),
        id: (0, _lodash.default)(farm, '_source.id')
      };
    });
    var products = (0, _lodash.default)(body, 'response.suggestionsProducts.options', []).map(function (product) {
      return {
        name: product.text
      };
    });
    var locations = (0, _lodash.default)(body, 'coordinateSearch.options', []).map(function (location) {
      return (0, _lodash.default)(location, '_source.name', {});
    });
    var suggestions = {
      // do not show product suggestions for schub theme
      products: theme === 'schub' ? [] : products,
      farms: farms,
      locations: locations
    };
    return (0, _lodash3.default)({}, state, {
      suggestions: suggestions
    });
  },
  'search-suggestions_REJECTED': function searchSuggestions_REJECTED(state) {
    return (0, _lodash3.default)({}, state, {
      loading: false
    });
  },
  //Load cantons
  'load-cantons_PENDING': function loadCantons_PENDING(state) {
    return (0, _lodash2.default)({}, state, {
      loading: true
    });
  },
  'load-cantons_FULFILLED': function loadCantons_FULFILLED(state, action) {
    var payload = action.payload;
    var isForeign = action.meta.isForeign;
    var language = action.meta.language;
    var cantons = payload.map(function (canton) {
      return {
        id: canton.id,
        name: canton.name,
        value: canton.name,
        parameterName: 'canton'
      };
    });
    var data = {
      loading: false,
      error: null,
      loaded: true
    };

    if (isForeign) {
      var foreignCanton = (0, _lodash2.default)({}, state.foreignCanton);
      foreignCanton[language] = cantons;
      data.foreignCanton = foreignCanton;
    } else {
      data.canton = cantons;
    }

    return (0, _lodash2.default)({}, state, data);
  },
  'load-cantons_REJECTED': rejectAction,
  //Load Products
  'load-product_PENDING': function loadProduct_PENDING(state) {
    return (0, _lodash2.default)({}, state, {
      loading: true
    });
  },
  'load-product_FULFILLED': function loadProduct_FULFILLED(state, action) {
    var payload = action.payload;
    var isForeign = action.meta.isForeign;
    var language = action.meta.language;
    var product = payload.data.map(function (product) {
      return {
        id: product.id,
        name: product.attributes.name,
        value: product.attributes.name,
        rubric_id: product.attributes.rubric_id,
        parameterName: 'products'
      };
    });
    var data = {
      loading: false,
      error: null
    };

    if (isForeign) {
      var foreignProducts = (0, _lodash2.default)({}, state.foreignProducts);
      foreignProducts[language] = product;
      data.foreignProducts = foreignProducts;
    } else {
      data.product = product;
    }

    return (0, _lodash2.default)({}, state, data);
  },
  'load-product_REJECTED': rejectAction,
  // Load rubric
  'load-rubric_PENDING': function loadRubric_PENDING(state) {
    return (0, _lodash2.default)({}, state, {
      loading: true
    });
  },
  'load-rubric_FULFILLED': function loadRubric_FULFILLED(state, action) {
    var payload = action.payload;
    var isForeign = action.meta.isForeign;
    var language = action.meta.language;
    var rubric = payload.data.map(function (type) {
      return {
        id: type.id,
        name: type.attributes.name,
        value: type.attributes.name,
        parameterName: 'rubric'
      };
    });
    var products = payload.data.map(function (product) {
      return {
        id: product.id,
        name: product.attributes.name,
        value: product.attributes.name,
        parameterName: 'products'
      };
    });
    var data = {
      loading: false,
      error: null
    };

    if (isForeign) {
      var foreignRubric = (0, _lodash2.default)({}, state.foreignRubric);
      foreignRubric[language] = rubric;
      data.foreignRubric = foreignRubric;
    } else {
      data.rubric = rubric;
      data.products = products;
    }

    return (0, _lodash2.default)({}, state, data);
  },
  'load-rubric_REJECTED': rejectAction,
  // Load vacation
  'load-vacation_PENDING': function loadVacation_PENDING(state) {
    return (0, _lodash2.default)({}, state, {
      loading: true
    });
  },
  'load-vacation_FULFILLED': function loadVacation_FULFILLED(state, action) {
    var payload = action.payload;
    var isForeign = action.meta.isForeign;
    var language = action.meta.language;
    var vacation = payload.map(function (type) {
      return {
        id: type.id,
        name: type.name,
        value: type.name,
        parameterName: 'vacation'
      };
    });
    var data = {
      loading: false,
      error: null
    };

    if (isForeign) {
      var foreignVacation = (0, _lodash2.default)({}, state.foreignVacation);
      foreignVacation[language] = vacation;
      data.foreignVacation = foreignVacation;
    } else {
      data.vacation = vacation;
    }

    return (0, _lodash2.default)({}, state, data);
  },
  'load-vacation_REJECTED': rejectAction,
  //Load brumch cantons
  'load-brunch-cantons_PENDING': function loadBrunchCantons_PENDING(state) {
    return (0, _lodash2.default)({}, state, {
      loading: true
    });
  },
  'load-brunch-cantons_FULFILLED': function loadBrunchCantons_FULFILLED(state, action) {
    var cantons = action.payload.map(function (canton) {
      return {
        id: canton.id,
        name: canton.name,
        value: canton.name,
        parameterName: 'brunchCanton'
      };
    });
    return (0, _lodash2.default)({}, state, {
      brunchCantons: cantons,
      loading: false,
      error: null
    });
  },
  'load-brunch-cantons_REJECTED': rejectAction,
  //Load productiontype
  'load-productiontype_PENDING': function loadProductiontype_PENDING(state) {
    return (0, _lodash2.default)({}, state, {
      loading: true
    });
  },
  'load-productiontype_FULFILLED': function loadProductiontype_FULFILLED(state, action) {
    var payload = action.payload;
    var isForeign = action.meta.isForeign;
    var language = action.meta.language;
    var productionTypes = payload.map(function (productionType) {
      return {
        id: productionType.id,
        name: productionType.name,
        value: productionType.name,
        parameterName: 'productionType'
      };
    });
    var data = {
      loading: false,
      error: null
    };

    if (isForeign) {
      var foreignProductionType = (0, _lodash2.default)({}, state.foreignProductionType);
      foreignProductionType[language] = productionTypes;
      data.foreignProductionType = foreignProductionType;
    } else {
      data.productionType = productionTypes;
    }

    return (0, _lodash2.default)({}, state, data);
  },
  'load-productiontype_REJECTED': rejectAction,
  //Load productiontype
  'load-projects_PENDING': function loadProjects_PENDING(state) {
    return (0, _lodash2.default)({}, state, {
      loading: true
    });
  },
  'load-projects_FULFILLED': function loadProjects_FULFILLED(state, action) {
    var hiddenProjects = ['toh', 'lgw', 'lockpfosten'];
    var payload = action.payload;
    var isForeign = action.meta.isForeign;
    var language = action.meta.language;
    var projects = payload.filter(function (project) {
      return !hiddenProjects.includes(project.project_key);
    }).map(function (project) {
      return {
        id: project.id,
        name: project.name,
        value: project.name,
        filterKey: project.project_key,
        parameterName: 'project',
        language: language
      };
    });
    var data = {
      loading: false,
      error: null
    };

    if (isForeign) {
      var foreignProject = (0, _lodash2.default)({}, state.foreignProject);
      foreignProject[language] = projects;
      data.foreignProject = foreignProject;
    } else {
      data.project = projects;
    }

    return (0, _lodash2.default)({}, state, data);
  },
  'load-projects_REJECTED': rejectAction,
  //Load soldout
  'load-soldout_PENDING': function loadSoldout_PENDING(state) {
    return (0, _lodash2.default)({}, state, {
      loading: true
    });
  },
  'load-soldout_FULFILLED': function loadSoldout_FULFILLED(state, action) {
    var soldouts = action.payload.map(function (soldout) {
      return {
        id: soldout.id,
        name: soldout.name,
        value: soldout.value,
        parameterName: 'soldout'
      };
    });
    return (0, _lodash2.default)({}, state, {
      soldout: soldouts,
      loading: false,
      error: null
    });
  },
  'load-soldout_REJECTED': function loadSoldout_REJECTED(state, action) {
    var message = action.payload.message;
    return (0, _lodash2.default)({}, state, {
      loading: false,
      error: message
    });
  },
  //Membership
  'load-membership_PENDING': function loadMembership_PENDING(state) {
    return (0, _lodash2.default)({}, state, {
      loading: true
    });
  },
  'load-membership_FULFILLED': function loadMembership_FULFILLED(state, action) {
    var payload = action.payload;
    var isForeign = action.meta.isForeign;
    var language = action.meta.language;
    var memberships = payload.reduce(function (prev, curr) {
      return prev.concat(curr);
    }, []).map(function (membership, index) {
      return {
        id: index,
        name: membership.name,
        value: membership.name,
        parameterName: 'membership'
      };
    });
    var data = {
      loading: false,
      error: null
    };

    if (isForeign) {
      var foreignMembership = (0, _lodash2.default)({}, state.foreignMembership);
      foreignMembership[language] = memberships;
      data.foreignMembership = foreignMembership;
    } else {
      data.membership = memberships;
    }

    return (0, _lodash2.default)({}, state, data);
  },
  'load-membership_REJECTED': rejectAction,
  //Search farms count
  'search-farms-count_PENDING': function searchFarmsCount_PENDING(state) {
    return (0, _lodash2.default)({}, state, {
      loading: true
    });
  },
  'search-farms-count_FULFILLED': function searchFarmsCount_FULFILLED(state, action) {
    var headers = action.payload.headers;
    return (0, _lodash2.default)({}, state, {
      loading: false,
      error: null,
      totalFarms: headers.get('X-Elasticsearch-Total') || 0
    });
  },
  'search-farms-count_REJECTED': function searchFarmsCount_REJECTED(state, action) {
    var message = action.payload.message;
    return (0, _lodash2.default)({}, state, {
      loading: false,
      error: message,
      totalFarms: 0
    });
  }
});
exports.farm = farm;


//////////////////
// WEBPACK FOOTER
// ./client/components/search/reducers.js
// module id = 595
// module chunks = 0